export type AutoCompleteOption =
    | {
          id: number;
          name: string;
      }
    | undefined;

export const SCHEDULE_ALLOWED_FILE_TYPES = ['.pdf', '.xlsx', '.xls', '.xml', '.csv'];
export const SCHEDULE_ALLOWED_FILE_TYPE_STRING = 'Supported file types: XLS, CSV, PDF, Agile XML';
export const SUBMITTAL_PACKAGE_ALLOWED_FILE_TYPES = ['.pdf'];
export const QUOTE_INSTRUCTION_STRING = 'Importing a Parspec Excel quote will NOT import Tax, or Freight values.';

export const SUBMITALL_PACKAGE_FILE_TYPE_STRING = 'Supported file types: PDF';
export const SCHEDULE = 'schedule';
export const SUBMITTAL_PACKAGE = 'submittal_package';
export const EXISTING_BOM_OPTION = 'existingBom';

export const IMPORT_OPTIONS = [
    { value: SCHEDULE, label: 'List of products (schedule, quote, etc.)' },
    {
        value: SUBMITTAL_PACKAGE,
        label: 'Existing submittal package and datasheets'
    },
    {
        value: EXISTING_BOM_OPTION,
        label: 'Existing Parspec BOM'
    }
];
const PATH_NAME = 'importProducts'
export const TAB_OPTIONS = [
    { label: 'Project files', value:`${PATH_NAME}/projectFiles`},
    { label: 'Upload', value: `${PATH_NAME}/upload` },
];